// extracted by mini-css-extract-plugin
module.exports = {"billInspCodesContainer":"BillInspCodes_billInspCodesContainer__3fUTp"};